import { Divider } from 'antd';

export const VerticalDivider = () => <Divider type="vertical" style={{ height: '100%' }} />;
